<template>
  <v-app>
    <v-parallax
      src="https://picsum.photos/1200/900?grayscale&blur=2"
      height="100%"
      class="fill-height"
    >
      <v-container
        id="dashboard"
        fluid
        class="fill-height"
        tag="section"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="10"
            sm="7"
            md="6"
            lg="4"
          >
            <base-material-card
              color="success"
              class="px-5 py-3"
            >
              <template v-slot:heading>
                <div class="display-2 font-weight-light text-center">
                  <v-avatar
                    size="40"
                    class="mb-4"
                  >
                    <v-img
                      contain
                      :src="logoImage"
                      alt="GarnetLogo"
                    />
                  </v-avatar>
                  <br>
                  {{ $t('welcome_to_garnet') }}
                </div>
              </template>
              <v-card-text class="text-center">
                <validation-observer
                  ref="observer"
                >
                  <form>
                    <validation-provider
                      v-slot="{ errors }"
                      name="email"
                      rules="required|email"
                    >
                      <v-text-field
                        v-model="email"
                        :error-messages="$t(errors)"
                        :label="$t('email')"
                        required
                        style="direction: ltr"
                        @keyup.13="submit"
                      />
                    </validation-provider>
                    <validation-provider
                      v-slot="{ errors }"
                      name="password"
                      rules="required"
                    >
                      <v-text-field
                        v-model="password"
                        :error-messages="$t(errors)"
                        :label="$t('password')"
                        type="password"
                        required
                        style="direction: ltr"
                        @keyup.13="submit"
                      />
                    </validation-provider>
                    <v-btn
                      tile
                      block
                      outlined
                      color="success"
                      class="fs-3"
                      :loading="loginLoading"
                      :disabled="loginLoading"
                      @keyup.13="submit"
                      @click="submit"
                    >
                      {{ $t('login') }}
                      <i class="fad fa-sign-in mx-3" />
                    </v-btn>
                  </form>
                </validation-observer>
              </v-card-text>
            </base-material-card>
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>
    <dashboard-core-footer />
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import { required, email } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import { mapState } from 'vuex'
  import Vue from 'vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: 'can_not_be_empty',
  })

  extend('email', {
    ...email,
    message: 'email_must_be_valid',
  })

  export default {
    name: 'Login',
    components: {
      ValidationProvider,
      ValidationObserver,
      DashboardCoreFooter: () => import('./components/Footer'),
    },
    data () {
      return {
        email: '',
        password: '',
        loginLoading: false,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
      }
    },
    computed: {
      ...mapState(['logoImage']),
    },
    created () {
    },
    methods: {
      submit () {
        this.$refs.observer.validate().then(success => {
          if (!success) {
            return
          }
          this.loginLoading = true
          this.$http.post('auth/login', {
            email: this.email,
            password: this.password,
          }).then(
            response => {
              switch (response.data.code) {
                case 2000: {
                  this.$session.start()
                  this.$session.set('jwtToken', response.data.token)
                  Vue.http.headers.common.token = response.data.token
                  this.$router.push('/')
                  break
                }
                case 2001: {
                  this.loginLoading = false
                  this.snackbarColor = 'error'
                  this.snackbarText = response.data.error
                  this.snackbar = true
                  break
                }
                case 2002: {
                  this.loginLoading = false
                  this.snackbarColor = 'error'
                  this.snackbarText = response.data.error
                  this.snackbar = true
                  break
                }
                default: {
                  this.loginLoading = false
                  this.snackbarColor = 'error'
                  this.snackbarText = response.data.error
                  this.snackbar = true
                  break
                }
              }
            }, error => {
              if (error) {
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ' | 0x901'
                this.snackbar = true
                this.loginLoading = false
              }
            }).catch(error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x902'
              this.snackbar = true
              this.loginLoading = false
            }
          })
        })
      },
    },
  }
</script>
